import { useMemo } from "react";
import { sanitizeRichText } from "@shared/utils";
import { cn } from "@shared/utils/cn";

interface RichTextContentProps {
  content?: string | null;
  className?: string;
  emptyPlaceholder?: string;
}

export function RichTextContent({
  content,
  className,
  emptyPlaceholder = "Sin contenido",
}: RichTextContentProps) {
  const sanitized = useMemo(() => {
    if (!content) return "";
    return sanitizeRichText(content);
  }, [content]);

  if (!sanitized) {
    return (
      <p className={cn("text-sm text-gray-500 italic", className)}>
        {emptyPlaceholder}
      </p>
    );
  }

  return (
    <div
      className={cn(
        "prose prose-sm max-w-none text-gray-800 [&_*]:leading-relaxed",
        // Estilos personalizados para headers
        "[&_h1]:text-2xl [&_h1]:font-bold [&_h1]:text-gray-900 [&_h1]:mt-6 [&_h1]:mb-4 [&_h1]:leading-tight",
        "[&_h2]:text-xl [&_h2]:font-bold [&_h2]:text-gray-900 [&_h2]:mt-5 [&_h2]:mb-3 [&_h2]:leading-tight",
        "[&_h3]:text-lg [&_h3]:font-semibold [&_h3]:text-gray-900 [&_h3]:mt-4 [&_h3]:mb-2 [&_h3]:leading-tight",
        "[&_h4]:text-base [&_h4]:font-semibold [&_h4]:text-gray-900 [&_h4]:mt-3 [&_h4]:mb-2",
        "[&_h5]:text-sm [&_h5]:font-semibold [&_h5]:text-gray-900 [&_h5]:mt-2 [&_h5]:mb-1",
        "[&_h6]:text-sm [&_h6]:font-medium [&_h6]:text-gray-800 [&_h6]:mt-2 [&_h6]:mb-1",
        // Estilos para otros elementos comunes
        "[&_p]:mb-4 [&_p]:text-gray-700",
        "[&_strong]:font-bold [&_strong]:text-gray-900",
        "[&_ul]:list-disc [&_ul]:ml-6 [&_ul]:mb-4 [&_ul]:space-y-1",
        "[&_ol]:list-decimal [&_ol]:ml-6 [&_ol]:mb-4 [&_ol]:space-y-1",
        "[&_li]:text-gray-700",
        "[&_blockquote]:border-l-4 [&_blockquote]:border-gray-300 [&_blockquote]:pl-4 [&_blockquote]:italic [&_blockquote]:text-gray-600 [&_blockquote]:my-4",
        className,
      )}
      dangerouslySetInnerHTML={{ __html: sanitized }}
    />
  );
}

